import { render, staticRenderFns } from "./SuratPenunjangPembayaran.vue?vue&type=template&id=a2cf6a74&"
import script from "./SuratPenunjangPembayaran.vue?vue&type=script&lang=js&"
export * from "./SuratPenunjangPembayaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports